package ru.notamedia.qah.models

sealed interface JsonValidationIssue {

    val path: String

    data class MissingField(
        override val path: String,
    ) : JsonValidationIssue

    data class UnexpectedField(
        override val path: String,
    ) : JsonValidationIssue

    data class TypeMismatch(
        override val path: String,
        val expectedType: String,
        val actualType: String,
    ) : JsonValidationIssue
}